import Model from "../classes/Model";
import SubscriptionApi from '../classes/api/Subscription';
import ValidationError from "../classes/ValidationError";

export default class Subscription extends Model {

    get id() {
        return this._id;
    }

    set name(value) {
        this._name = value;
    }
    get name() {
        return this._name;
    }

    set price(value) {
        this._price = value;
    }
    get price() {
        return this._price;
    }

    set days(value) {
        this._days = value;
    }
    get days() {
        return this._days;
    }

    set count(value) {
        this._count = value;
    }
    get count() {
        return this._count;
    }

    set canSale(value) {
        this._canSale = value;
    }

    set status(value) {
        this._status = value;
    }

    get status() {
        return this._status;
    }

    get canSale() {
        return this._canSale;
    }



    set comment(value) {
        this._comment = value;
    }
    get comment() {
        return this._comment;
    }

    set maxTime(value) {
        this._maxTime = value;
    }
    get maxTime() {
        return this._maxTime;
    }

    set maxTimeWeekend(value) {
        this._maxTimeWeekend = value;
    }
    get maxTimeWeekend() {
        return this._maxTimeWeekend;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }


    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            name: this.name,
            price: this.price,
            days: this.days,
            count: this.count,
            status: this.status,
            can_sale: this.canSale ? 1 : 0,
            comment: this.comment,
            max_time: this.maxTime,
            max_time_weekend: this.maxTimeWeekend,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            name: data.name,
            price: data.price,
            days: data.days,
            count: data.count,
            canSale: data.can_sale ? true : false,
            comment: data.comment,
            status: data.status,
            maxTime: data.max_time,
            maxTimeWeekend: data.max_time_weekend,
            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined) {
        return SubscriptionApi.getList(page, perPage, sort).then((response) => {
            let data = [];
            for (let subscription of response.data) {
                data.push(new this(this.toResponse(subscription)));
            }
            return {data, headers: response.headers};
        });
    }

    static getListActive(page = 1, perPage = 10, sort = undefined) {
        return SubscriptionApi.getListActive(page, perPage, sort).then((response) => {
            let data = [];
            for (let subscription of response.data) {
                data.push(new this(this.toResponse(subscription)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return SubscriptionApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return SubscriptionApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Subscription(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return SubscriptionApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}
